var _g, _line, _g2, _g3, _line2, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "212px",
    height: "232px",
    viewBox: "0 0 212 232",
    enableBackground: "new 0 0 212 232",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.1479,
    x1: 15.9,
    y1: 9.7,
    x2: 15.9,
    y2: 224.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "12.5,10.7 15.9,4.7 19.3,10.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "12.5,223.4 15.9,229.3 19.3,223.4  "
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.1356,
    x1: 2.7,
    y1: 230.2,
    x2: 178.7,
    y2: 230.2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M186.8,230.6v-4.8h3.2v0.5h-2.6v1.6h2.5v0.5h-2.5v2.2H186.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M190.7,230.6v-4.8h0.6v4.3h2.3v0.5H190.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M194.4,229.4c-0.2-0.4-0.3-0.8-0.3-1.3s0.1-0.9,0.3-1.3c0.2-0.4,0.5-0.7,0.9-0.9s0.8-0.3,1.3-0.3 c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.8,0.3,1.3s-0.1,0.9-0.3,1.3s-0.5,0.7-0.9,0.9 c-0.4,0.2-0.8,0.3-1.3,0.3c-0.5,0-0.9-0.1-1.3-0.3S194.6,229.8,194.4,229.4z M194.8,228.1c0,0.4,0.1,0.7,0.2,1 c0.1,0.3,0.4,0.5,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3s0.7-0.1,0.9-0.3s0.5-0.4,0.6-0.7c0.1-0.3,0.2-0.6,0.2-1c0-0.6-0.2-1-0.5-1.4 c-0.3-0.4-0.8-0.6-1.3-0.6c-0.5,0-1,0.2-1.3,0.6C194.9,227.1,194.8,227.6,194.8,228.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M200,229.4c-0.2-0.4-0.3-0.8-0.3-1.3s0.1-0.9,0.3-1.3c0.2-0.4,0.5-0.7,0.9-0.9s0.8-0.3,1.3-0.3 c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.8,0.3,1.3s-0.1,0.9-0.3,1.3s-0.5,0.7-0.9,0.9 c-0.4,0.2-0.8,0.3-1.3,0.3c-0.5,0-0.9-0.1-1.3-0.3S200.2,229.8,200,229.4z M200.3,228.1c0,0.4,0.1,0.7,0.2,1 c0.1,0.3,0.4,0.5,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3s0.7-0.1,0.9-0.3s0.5-0.4,0.6-0.7c0.1-0.3,0.2-0.6,0.2-1c0-0.6-0.2-1-0.5-1.4 c-0.3-0.4-0.8-0.6-1.3-0.6c-0.5,0-1,0.2-1.3,0.6C200.5,227.1,200.3,227.6,200.3,228.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M205.5,230.6v-4.8h1.9c0.5,0,0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1.1c0,0.2,0,0.4-0.1,0.6 c-0.1,0.2-0.2,0.3-0.3,0.4s-0.3,0.2-0.4,0.3c-0.2,0.1-0.3,0.1-0.5,0.1l1.3,2h-0.7l-1.2-1.9h-1v1.9H205.5z M206.1,228.1h1.3 c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3h-1.3V228.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.1,
    y: 50.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1479,
    strokeMiterlimit: 10,
    width: 107.2,
    height: 148.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.9,
    y: 59.7,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1479,
    strokeMiterlimit: 10,
    width: 89.5,
    height: 131.2
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.1356,
    x1: 2.7,
    y1: 4.2,
    x2: 178.7,
    y2: 4.2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M183.4,4.7c-0.1-0.3-0.2-0.7-0.2-1c0-0.4,0.1-0.7,0.2-1c0.1-0.3,0.3-0.6,0.5-0.8c0.2-0.2,0.5-0.4,0.8-0.5 c0.3-0.1,0.6-0.2,1-0.2c0.8,0,1.4,0.3,1.8,1l-0.5,0.3c-0.1-0.2-0.3-0.4-0.6-0.5s-0.5-0.2-0.8-0.2c-0.5,0-1,0.2-1.3,0.6 c-0.4,0.4-0.5,0.8-0.5,1.4c0,0.4,0.1,0.7,0.2,1c0.2,0.3,0.4,0.5,0.7,0.7c0.3,0.2,0.6,0.3,1,0.3c0.3,0,0.5-0.1,0.8-0.2 c0.2-0.1,0.4-0.3,0.6-0.5l0.5,0.3c-0.5,0.6-1.1,1-1.8,1c-0.3,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.5 C183.8,5.2,183.6,5,183.4,4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M188.4,6.1V1.2h3.2v0.5H189v1.6h2.5v0.5H189v1.7h2.6v0.5H188.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M192.5,6.1V1.2h0.6v4.8H192.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M194.2,6.1V1.2h0.6v4.3h2.3v0.5H194.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M197.8,6.1V1.2h0.6v4.8H197.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M199.6,6.1V1.2h0.6L203,5V1.2h0.6v4.8H203l-2.8-3.9v3.9H199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M204.7,4.7c-0.1-0.3-0.2-0.7-0.2-1c0-0.4,0.1-0.7,0.2-1c0.1-0.3,0.3-0.6,0.5-0.8s0.5-0.4,0.8-0.5 c0.3-0.1,0.6-0.2,1-0.2c0.8,0,1.4,0.3,1.9,0.9l-0.5,0.3c-0.2-0.2-0.4-0.4-0.6-0.5s-0.5-0.2-0.8-0.2c-0.5,0-1,0.2-1.3,0.6 c-0.4,0.4-0.5,0.8-0.5,1.4c0,0.4,0.1,0.7,0.2,1c0.2,0.3,0.4,0.5,0.7,0.7c0.3,0.2,0.6,0.3,1,0.3c0.3,0,0.5-0.1,0.8-0.2 c0.2-0.1,0.4-0.2,0.6-0.4v-1h-1.7V3.6h2.3v1.8c-0.2,0.3-0.5,0.5-0.8,0.6c-0.3,0.1-0.7,0.2-1.1,0.2c-0.3,0-0.7-0.1-1-0.2 c-0.3-0.1-0.6-0.3-0.8-0.5C205,5.2,204.8,5,204.7,4.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.2,
    y: 29.3,
    fill: "#FFFFFF",
    width: 137,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2,
    y: 29.3,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 0.5958,
    width: 137,
    height: 4.3
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5D);
export default __webpack_public_path__ + "static/media/5d.a29188d30bae81f3c9d84a8436d71bec.svg";
export { ForwardRef as ReactComponent };